import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'hanwha_logs'

// sectors/centers/cameras_types join through the hanwha_cameras branch, which
// multiplies every log by the DVR's cameras (measured: $count 91,738 alone vs
// 1,376,070 touching cameras_types), so nothing of that branch is offered.
// view_camera_name resolves null on every row (hanwha_logs.id_camera_proxy is
// not populated), so the camera filter is left out too.
const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: {},                              // units.description (via hanwha_dvrs.id_unit)
  REGION: {},                                    // regions.name
  MUNICIPALITY: {},                              // municipalities.name
  SECTOR: false,                                 // hanwha_cameras branch: fans out
  CENTER: false,                                 // hanwha_cameras branch: fans out
  TENANT: {},                                    // tenants.name (via hanwha_dvrs.id_tenant)
  STATUS: { column: 'view_alarm_status.alarm_status', label: 'Estatus de alarma' },
  USER: false,                                   // no users join
})

export default {
  key: DATASET_KEY,
  label: 'Logs Hanwha',
  timeColumn: 'hanwha_logs.date',
  permission: { action: 'read', subject: 'HanwhaCamera' },

  tables: {
    hanwha_logs: ["id", "id_hanwha_dvr", "type", "type_log", "description", "channel", "camera_event", "id_camera_proxy", "alarm_id", "resolved_at", "alarm_dispatched_at", "date", "created_at", "updated_at"],
    hanwha_dvrs: ["id", "name", "id_tenant", "id_unit", "model", "online"],
    units: ["id", "description", "id_region", "id_municipality"],
    regions: ["id", "name"],
    municipalities: ["id", "name"],
    tenants: ["id", "name"],
    view_alarm_status: ["id_alarm", "alarm_status"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'hanwha_logs.type',
  },

  csvConfig: {
    columns: 'hanwha_logs.date,hanwha_logs.type,hanwha_logs.type_log,hanwha_logs.camera_event,hanwha_logs.channel,hanwha_logs.description,hanwha_dvrs.name,units.description,regions.name,municipalities.name,tenants.name,view_alarm_status.alarm_status',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'hanwha_logs.type', label: 'Tipo de evento' },
    { key: 'hanwha_logs.type_log', label: 'Tipo de log' },
    { key: 'hanwha_dvrs.name', label: 'Grabador' },
    { key: 'units.description', label: 'Inmueble' },
    { key: 'regions.name', label: 'Estado' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'tenants.name', label: 'Tenant' },
    { key: 'hanwha_logs.date', label: 'Fecha del evento', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    ...commonFilters,
    embedFilter(DATASET_KEY, 'hanwha_logs.type', 'Tipo de evento', 'type'),
    embedFilter(DATASET_KEY, 'hanwha_logs.type_log', 'Tipo de log', 'type_log'),
    embedFilter(DATASET_KEY, 'hanwha_logs.camera_event', 'Evento de cámara', 'camera_event'),
    embedFilter(DATASET_KEY, 'hanwha_dvrs.name', 'Grabador', 'group'),
  ],

  dateGrouping: {
    column: 'hanwha_logs.date',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
